import React from 'react';

import { ComponentProps, TextRowComponent } from '../FormikTextRow';
import { replacePhoneNumberWithSpace } from 'services/formatter';

export default function TelephoneRowComponent({
  beforeOnChange,
  ...props
}: ComponentProps): JSX.Element {
  return (
    <TextRowComponent
      {...props}
      beforeOnChange={e => {
        beforeOnChange && beforeOnChange(e);
        const el = e.target as HTMLInputElement;

        el.value = replacePhoneNumberWithSpace(el.value);
      }}
    />
  );
}
